import _ from '../utils'

const CAPTCHA_CONFIG = {
    publicKey: document.documentElement.getAttribute( 'data-google-recaptcha' )
}

export default CAPTCHA_CONFIG